var _defs, _rect, _path, _path2, _path3, _polygon, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyStateSelectOffer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 155 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2,.cls-3,.cls-4{fill:#0089e5;}.cls-2{opacity:0.2;}.cls-3{opacity:0.1;}.cls-4{opacity:0.3;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "empty state - mensagens") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 57.51,
    width: 155,
    height: 92.49
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M152,150H3A3.05,3.05,0,0,1,0,147V57.51H155V147A3.05,3.05,0,0,1,152,150Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M153.11,50.13,80,.78A4.49,4.49,0,0,0,75,.78L1.57,50.35a3.57,3.57,0,0,0-1.57,3v4.2l75,50.63a4.49,4.49,0,0,0,5.06,0l75-50.63V53.69A4.3,4.3,0,0,0,153.11,50.13Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M153.11,50.13,80,.78A4.49,4.49,0,0,0,75,.78L1.57,50.35a3.57,3.57,0,0,0-1.57,3v4.2l75,50.63a4.49,4.49,0,0,0,5.06,0l75-50.63V53.69A4.3,4.3,0,0,0,153.11,50.13Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "77.5 109.85 14.94 67.6 14.94 54.46 140.06 54.46 140.06 67.6 77.5 109.85"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M81.22,97.12,155,147a3.05,3.05,0,0,1-3,3.05H3A3.05,3.05,0,0,1,0,147L73.78,97.12A6.64,6.64,0,0,1,81.22,97.12Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M81.07,97,155,147a3.05,3.05,0,0,1-3,3.05H3A3.05,3.05,0,0,1,0,147L73.93,97A6.37,6.37,0,0,1,81.07,97Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateSelectOffer);
export default __webpack_public_path__ + "static/media/empty-state-select-offer.5febe164.svg";
export { ForwardRef as ReactComponent };